export const setAuctionUser = (auctionUser) => ({
  type: "SET_AUCTION_USER",
  payload: auctionUser
})

export const setBidSubscriptionResponse = (bidSubscriptionResponse) => ({
  type: "SET_BID_SUBSCRIPTION_RESPONSE",
  payload: bidSubscriptionResponse
})

export const setFixedItemSubscriptionResponse = (fixedItemSubscriptionResponse) => ({
  type: "SET_FIXED_ITEM_SUBSCRIPTION_RESPONSE",
  payload: fixedItemSubscriptionResponse
})

export const setDonationSubscriptionResponse = (donationSubscriptionResponse) => ({
  type: "SET_DONATION_SUBSCRIPTION_RESPONSE",
  payload: donationSubscriptionResponse
})

export const setLiveAuctionCode = (auctionCode) => ({
  type: "SET_LIVE_AUCTION",
  payload: auctionCode
})


